import http from "@/util/http.js"
import vueInstance from "@/main"
import querystring from "querystring"
import LoginUtils from "../util/LoginUtils"

export default {
    async login(login, password, customConfig)
    {
        let params = {
            grant_type: "password",
            scope: "webclient",
            username: login,
            password: password
        }

        let deviceAndCache = LoginUtils.getDeviceAndCash(login)

        let headers = {
            "Authorization": 'Basic ' + process.env.VUE_APP_TOKEN_APP,
            "Content-Type": "application/x-www-form-urlencoded"
        }

        if (deviceAndCache && deviceAndCache.id) {
            params["X-P-DEVICE"] = deviceAndCache.id

            if (deviceAndCache.cache) {
                params["X-P-CACHE"] = deviceAndCache.cache
            }
        }

        let response

        try
        {
            response = await http.post("/oauth/token", querystring.stringify(params), { headers, customConfig })
        }
        catch (error)
        {
            let errorMessage = error.error == "invalid_grant" ? "validation.context.login.invalid_grant" : "validation.context.login.authentication_error"
            throw {message: vueInstance.$t(errorMessage)}
            
        }

        if (!response || !response.access_token)
        {
            throw {message: vueInstance.$t("validation.context.login.authentication_error")}
        }

        return {accessToken: response.access_token, refreshToken: response.refresh_token}
    },
    async loginSecondStep(token, reliableDevice, customConfig)
    {
        let device = LoginUtils.getDevice()
        
        return await http.post('/oauth/mfa/second-step', null, {params: { tokenMFA: token, device, reliableDevice }, customConfig})
    },
    async sendToken(shippingType, celular, customConfig)
    {   
        return await http.post('/oauth/mfa/send-token', null, { params: { celular, shippingType: shippingType }, customConfig})
    },
    async getQrCode(customConfig) {
        return await http.get('/oauth/mfa/totp/qrcode', {customConfig })
    },
    async loginSecondStepByTotp(code, customConfig)  {
        return await http.post("/oauth/mfa/totp/second-step", null, { params: { code: code },  customConfig, });
      },
  }